import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import _ from 'lodash';

// will commit change only when enter is pressed, will revert to initial prop value on blur
export default class InputWrapper extends Component {

  constructor(props) {
    super();
    const {value, defaultValue, type} = props;
    if (!_.isNil(value)) {
      this.state = {value};
    } else if (!_.isNil(defaultValue)) {
      this.state = {value: defaultValue};
    } else {
      this.state = {value: type === 'number' ? 0 : ''};
    }
    this.state.id = _.uniqueId('customTextField_');
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
  };

  handleInputKeyDown = (event) => {
    const {type, min, max} = this.props;
    const isNumber = (type === 'number');
    let value;
    let newValue;
    let diff;
    if (isNumber) {
      value = parseInt(this.state.value, 10);
      if (!_.isNumber(value)) {
        value = 0;
      }
      if (event.shiftKey) {
        diff = 10;
      } else {
        diff = 1;
      }
    }
    switch (event.keyCode) {
      case 13:
        newValue = value;
        break;
      case 38:
        if (isNumber) {
          newValue = value + diff;
        }
        break;
      case 40:
        if (isNumber) {
          newValue = value - diff;
        }
        break;
      default:
        return;
    }
    if (isNumber) {
      newValue = Math.max(newValue, min);
      if (!_.isNil(max)) {
        newValue = Math.min(newValue, max);
      }
      this.setState({value: newValue});
      this.throttledUpdate({target: {value: newValue}});
    }
  };

  handleChange = (event) => {
    if (Math.abs(this.state.value - event.target.value) === 1) { // when using the stepper changes should take effect imidialty.
      this.props.onChange(event);
    }
    this.setState({value: event.target.value});
  };

  throttledUpdate = _.throttle((event) => {
    this.props.onChange(event);
  }, 200);

  render() {
    const {type, showSteppers} = this.props;
    return (<TextField
      {...this.props}
      id={this.state.id}
      type={showSteppers ? type : null}
      onChange={this.handleChange}
      onKeyDown={this.handleInputKeyDown}
      onBlur={() => {this.setState({value: this.props.value});}}
      value={this.state.value}
    />);
  }
}

InputWrapper.propTypes = {
  type: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
};

InputWrapper.defaultProps = {
  min: 0,
};